import styled from 'styled-components';

const Wrapper = styled.section`
  min-height: 100vh;
  background: transparent;

  .dashboard-page {
    width: min(1180px, 92vw);
    margin: 0 auto;
    padding: 2.25rem 0 3.5rem;
  }
`;

export default Wrapper;
